import React from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../../constants/path';

import LinkButtonComponent from '../../../button/LinkButtonComponent';

const LimitedAccessComponent = ({ i18n }) => (
    <div className="limitedAccess">
        <p className="limitedAccess-title">{i18n.LIMITED_TITLE}</p>
        <p className="limitedAccess-text">{i18n.LIMITED_TEXT}</p>
        <div className="limitedAccess-action">
            <LinkButtonComponent
                color="main"
                to={PATH.ACCOUNT_JACKPOT_PATH}
                title={i18n.LIMITED_BUTTON}
                text={i18n.LIMITED_BUTTON}
            />
        </div>
    </div>
);

const mapStateToProps = state => ({
    i18n: state.i18n.page.AUTHENTICATION
});

export default connect(mapStateToProps)(LimitedAccessComponent);



// WEBPACK FOOTER //
// ./src/components/pages/authentication/login-choice/LimitedAccessComponent.js